const ASC = 'asc';
const DESC = 'desc';

// eslint-disable-next-line import/prefer-default-export
export const sortDirections = {
  ASC,
  DESC,
};
